import { render, staticRenderFns } from "./orders-table.vue?vue&type=template&id=085f3d3e&scoped=true&lang=pug"
import script from "./orders-table.js?vue&type=script&lang=js&external"
export * from "./orders-table.js?vue&type=script&lang=js&external"
import style0 from "./orders-table.vue?vue&type=style&index=0&id=085f3d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f3d3e",
  null
  
)

export default component.exports